import { combineReducers } from 'redux'
import { createReducer } from 'helpers/ReducerUtil'
import {
  TOGGLE_COLLAPSE,
  UPDATE_PROJECT_INFO,
  UPDATE_PROJECT_WORKFLOW,
  CLEAR_PROJECT_INFO,
  SCROLL_TOP,
} from './constants'

const toggleCollapse = (collapse) => !collapse
const updateType = (key, action) => action.key
const updateId = (id, action) => action.value
const clear = () => null

const entityTypeReducer = createReducer(null, {
  [UPDATE_PROJECT_INFO]: updateType,
  [CLEAR_PROJECT_INFO]: clear,
})

const entityIdReducer = createReducer(null, {
  [UPDATE_PROJECT_INFO]: updateId,
  [CLEAR_PROJECT_INFO]: clear,
})

const projectDetailReducer = combineReducers({
  type: entityTypeReducer,
  id: entityIdReducer,
})

const workflowTypeReducer = createReducer(null, {
  [UPDATE_PROJECT_WORKFLOW]: updateType,
  [CLEAR_PROJECT_INFO]: clear,
})

const workflowIdReducer = createReducer(null, {
  [UPDATE_PROJECT_WORKFLOW]: updateId,
  [CLEAR_PROJECT_INFO]: clear,
})

const projectWorkflowReducer = combineReducers({
  type: workflowTypeReducer,
  id: workflowIdReducer,
})

const collapseUiReducer = createReducer(false, {
  [TOGGLE_COLLAPSE]: toggleCollapse,
})


const isScrolledTop = createReducer(true, {
  [SCROLL_TOP]: (prev, { isTop }) => isTop
})

const projectViewUiReducer = combineReducers({
  collapse: collapseUiReducer,
  scrolledTop: isScrolledTop,
})

export {
  projectDetailReducer,
  projectViewUiReducer,
  projectWorkflowReducer,
}

export default projectDetailReducer
